module.exports = __webpack_public_path__ + "img/download.f8f66371.png";